<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>



    <el-form ref="form" :rules="rules" :model="formData" label-width="250px">
      <el-form-item prop="title" label="标题">
        <el-input type="textarea" size="small" style="width: 500px" v-model="formData.title"
                  placeholder="请输入标题"></el-input>
      </el-form-item>

      <el-form-item label="请选择省份">
        <SelectProvince ref="selectProvince" width="500px" v-model="formData.province_id" @province-change="onProvinceChange"></SelectProvince>
      </el-form-item>

      <el-form-item label="请选择城市">
        <SelectCity ref="selectCity" width="500px" v-model="formData.city_id" :provinceId="formData.province_id" @city-change="onCityChange" @list-loaded="onCityListLoaded"></SelectCity>
      </el-form-item>

      <el-form-item label ="请选择导航">
        <SelectGuides width="500px" v-model="formData.guide_ids"></SelectGuides>
      </el-form-item>

      <el-form-item label="公告类型">
        <el-select v-model="formData.type" style="width: 500px"  placeholder="请选择">
          <el-option label="招标公告" value="10" key="10"></el-option>
          <el-option label="变更公告" value="20" key="20"></el-option>
          <el-option label="中标公告" value="30" key="30"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker v-model="formData.publish_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="详情">
        <Editor ref="editor" :showBtn="false" :content.sync="formData.content"></Editor>
      </el-form-item>

      <el-form-item label=" ">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" type="" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {addAPI, editAPI, getDetailAPI} from './api'
import SelectProvince from '@/components/select-area/select-province.vue'
import SelectCity from '@/components/select-area/select-city.vue'
import Editor from '@/components/editor/index.vue'
import SelectGuides from '@/views/biaoxun/guide/select-guides.vue'

export default {
  name: 'Update',
  components: {SelectProvince, SelectCity, Editor, SelectGuides},
  data() {
    return {
      formData: {
        title: '',
        tag: null,
        type: '10', // 默认招标公告
        city_name: '',
        province_id: '',
        city_id: '',
        publish_time: this.getCurrentDateTime(), // 默认当前时间
        content: '',
        guide_ids: [],
      },
      rules: {
                title: [
                    {
                        required: true,
                        message: '标题必填',
                        trigger: 'blur'
                    }
                ]
            }
    }
  },

  mounted() {
    if (this.$route.params.id) this.getDetail()
  },
  methods: {
    getCurrentDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    cancel() {
      this.$router.back(-1)
    },
    convertToArr(val) {
      // 如果 val 是一个数字或字符串，则将其转换为数组
      if (typeof val === 'number' || typeof val === 'string') {
        return [val]
      }
      // 如果 val 已经是一个数组，则直接返回
      if (Array.isArray(val)) {
        return val
      }
      // 如果 val 为空或 undefined，则返回一个空数组
      return []
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.$router.back()
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功')
              this.$router.back()
            })
          }
        }
      })
    },
    async getDetail() {
      const res = await getDetailAPI(this.$route.params.id)
      this.formData = res
      if (this.formData && this.formData.type) {
        this.formData.type = this.formData.type.toString()
      }
      this.formData.content = res?.detail?.content || ''
    },

    onCityListLoaded() {
      if (this.formData.city_id && this.$refs.selectCity && this.$refs.selectCity.cityList) {
        const selectedCity = this.$refs.selectCity.cityList.find(item => item.id == this.formData.city_id)
        if (selectedCity) {
          this.formData.city_name = selectedCity.name
        }
      }
    },

    onProvinceChange(provinceData) {
      // 省份变化时，清空城市选择
      this.formData.city_id = ''
      this.formData.city_name = ''
      // 更新城市名称为省份名称（如果需要的话）
      if (provinceData && provinceData.name) {
        // 这里可以根据业务需求决定是否需要设置省份名称
      }
    },

    onCityChange(cityData) {
      // 城市变化时，更新city_name
      if (cityData && cityData.name) {
        this.formData.city_name = cityData.name
      } else {
        this.formData.city_name = ''
      }
    }
  }
}
</script>
